export function getExtractedValueForBarcode(input) {

  const regexPatterns = JSON.parse(window.localStorage.getItem('cn_extraction_regex_list') || '[]');

    for (const pattern of regexPatterns) {
      const matchRegex = new RegExp(pattern.match_regex);
      if (matchRegex.test(input)) {
        const extractionRegex = new RegExp(pattern.extraction_regex);
        const match = input.match(extractionRegex);
        if (match) {
          return match[1]; 
        }
      }
    }
    
    return null; 
}

export const checkIfValidReferenceNumber = (referenceNumber: string): boolean => {
  const consignmentRegex = JSON.parse(window.localStorage.getItem('consignment_regex_list')) || [];
  // if nothing is set, return true
  if (!Array.isArray(consignmentRegex) || consignmentRegex.length === 0) {
    return true;
  }
  const regexList = consignmentRegex.map(function (elem) {
    return new RegExp(elem);
  });

  if (!referenceNumber)
    return false;

  return regexList.some(function (reg) {
    return referenceNumber.match(reg);
  });
};

export const sendGenericWebViewAction = (action: string, payload: any) => {
  const isIOS = /iP(hone|od|ad)/.test(navigator.userAgent);
  if (isIOS) {
      (window as any).webkit?.messageHandlers?.webClientListener?.postMessage(
          JSON.stringify({
              action,
              payload,
          }),
      );
  } else {
      (window as any)?.AndroidListener?.postWebViewActions(
          JSON.stringify({
              action,
              payload,
          }),                          
      );
  }
};

export const getURLForMaps = (latitude: number, longitude: number, address: string): string => {
  const isIOS = /iP(hone|od|ad)/.test(navigator.userAgent);
  const label = encodeURIComponent(address);
  let url: string;

  if (isIOS) {
      url = `maps://?q=${latitude},${longitude}(${label})`;
  } else {
      url = `geo:${latitude},${longitude}?q=${latitude},${longitude}(${label})`;
  }

  return url; 
};



let soundTimeout: NodeJS.Timeout | null = null;



export interface AnalyticsEvent {
  event_name: string;
  event_params: Record<string, unknown>;
}

export interface CloseWebviewArgs {
  success: boolean;
  eventType?: string;
  analyticsEvent?: AnalyticsEvent;
  extraData?: Record<string, unknown>;
}

// Android-only per app-team contract; the native side will force-release the app
// build that handles `close_webview` before we ship this. iOS isn't wired here yet.
export const closeWebviewWithResult = (args: CloseWebviewArgs): void => {
  const body: Record<string, unknown> = { success: args.success };
  if (args.eventType) body.event_type = args.eventType;
  if (args.analyticsEvent) body.analytics_event = args.analyticsEvent;
  if (args.extraData) body.extra_data = args.extraData;
  (window as any).Android?.runAction?.('close_webview', JSON.stringify(body));
};

// Fire-and-forget analytics event, decoupled from any close action.
export const sendAnalyticsEvent = (
  eventName: string,
  eventParams: Record<string, unknown>,
): void => {
  (window as any).Android?.sendAnalyticsEvent?.(eventName, JSON.stringify(eventParams));
};

export const playSound = (soundType: string) => {

    if (soundTimeout) {
        clearTimeout(soundTimeout);

    }

    const soundMap = {
      scan_success: '/sounds/success.mp3',
      scan_failure: '/sounds/failure.mp3',
    };

    soundTimeout = setTimeout(() => {

        const audio = new Audio(soundMap[soundType]);

        audio.play();

    }, 100); 

};